import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getHeatmapOptions } from './getHeatmapChartOptions';
import { getHistogramChartOptions } from './getHistogramChartOptions';
import useChart from '../../../hooks/useChart';

const CombinationChart = ({ config, data, players }) => {
  const heatmapOptions = useMemo(
    () => getHeatmapOptions(config, data, players),
    [config, data, players],
  );
  const histogramOptions = useMemo(
    () => getHistogramChartOptions(config, data),
    [config, data],
  );

  const heatmap = useChart(heatmapOptions);
  const histogram = useChart(histogramOptions);

  if (!data || !data.length) return '';

  return (
    <div className="s-combination-explorer__chart-container">
      <div className="s-combination-explorer__chart-heatmap" ref={heatmap} />
      <div className="s-combination-explorer__chart-histogram-container">
        <div
          className="s-combination-explorer__chart-histogram"
          ref={histogram}
        />
      </div>
    </div>
  );
};

CombinationChart.propTypes = {
  config: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  players: PropTypes.array.isRequired,
};

export default CombinationChart;
